import Vue from 'vue'

import utils from '@/utils'



//数量
Vue.filter('filterNum', utils.filterNum)

Vue.filter('filterOpt', utils.filterOpt)
Vue.filter('time2', utils.time2)

Vue.filter('filterImg',utils.filterImg)


